const types = {
	active: 'active',
	closed: 'closed',
	paused: 'paused'
};

const locale = {
	ru: {
		active: 'активный',
		closed: 'закрытый',
		paused: 'на паузе'
	},
	en: types,
	uk: types,
	de: {
		active: 'aktiv',
		closed: 'geschlossen',
		paused: 'pausiert'
	},
	vi: types,
	th: {
		active: 'ใช้งานได้',
		closed: 'ปิดแล้ว',
		paused: 'หยุดชั่วคราว'
	}
};

locale.affiliate_dashboard = Object.assign({}, locale, {
	ru: Object.assign({}, locale.ru, { paused: 'активный' }),
	en: Object.assign({}, locale.en, { paused: 'active' }),
	de: Object.assign({}, locale.de, { paused: 'aktiv' }),
	vi: Object.assign({}, locale.en, { paused: 'active' }),
	th: Object.assign({}, locale.th, { paused: 'ใช้งานได้' })
});

module.exports = {
	enum: types,
	locale: locale
};



// WEBPACK FOOTER //
// ./enums/thread-statuses.js